import React from "react";
import Title from "./Title";
import Content from "./Content";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";

const ExtraFees = () => {
    return (
        <PageContentWrapper>
            <Title />
            <Content />
        </PageContentWrapper>
    );
};

export default ExtraFees;
